/* SIVIA SOFA · Premium experience layer
   Hero parallax (desktop only), Room Studio, Complete-the-room compositions, 2D living-room planner.
   Cart adds go through window.SX.addItems (native /cart/add.js + real cart drawer refresh). */
(function () {
  'use strict';
  var d = document;
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function money(c) { return '$' + ((+c || 0) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function add(items, btn, msg) {
    if (!items.length) { if (msg) msg.textContent = 'Select at least one available piece.'; return; }
    if (!window.SX || !SX.addItems) { if (msg) msg.textContent = 'Cart is still loading, please try again.'; return; }
    if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }
    if (msg) msg.textContent = 'Adding to your cart…';
    SX.addItems(items).then(function () {
      if (msg) msg.textContent = items.length + (items.length > 1 ? ' pieces' : ' piece') + ' added to your cart.';
      if (btn) { btn.classList.add('is-done'); setTimeout(function () { btn.classList.remove('is-done'); }, 1600); }
      d.querySelectorAll('.header-actions__cart-icon, cart-icon, .cart-bubble').forEach(function (e) { e.classList.remove('sxp-bump'); void e.offsetWidth; e.classList.add('sxp-bump'); });
    }).catch(function (e) {
      if (msg) msg.textContent = (e && e.message) || 'Could not add to cart. Please try again.';
    }).then(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); } });
  }

  /* ---------- Hero parallax: desktop, motion allowed, only while visible ---------- */
  function parallax() {
    var m = $('[data-sxp-parallax]');
    if (!m || RM || !window.matchMedia('(min-width: 990px) and (hover: hover)').matches) return;
    var hero = m.closest('section') || m, vis = true, raf = 0;
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { vis = e[0].isIntersecting; }).observe(hero);
    window.addEventListener('scroll', function () {
      if (!vis || raf) return;
      raf = requestAnimationFrame(function () { raf = 0; var y = Math.min(window.scrollY, hero.offsetHeight); m.style.transform = 'translate3d(0,' + (y * 0.12).toFixed(1) + 'px,0)'; });
    }, { passive: true });
  }

  /* ---------- Room Studio ---------- */
  function studio(root) {
    var pop = $('[data-st-pop]', root), stage = $('[data-st-stage]', root), open = null;
    var boxes = $$('input[data-st-v]', root), totalEl = $('[data-st-total]', root), countEl = $('[data-st-count]', root);
    function sum() {
      var t = 0, n = 0;
      boxes.forEach(function (b) { if (b.checked && !b.disabled) { t += +b.getAttribute('data-st-p'); n++; } });
      if (totalEl) totalEl.textContent = money(t);
      if (countEl) countEl.textContent = n + (n === 1 ? ' piece' : ' pieces');
      $$('[data-st-toggle]', root).forEach(function (b) {
        var box = $('input[data-st-v="' + b.getAttribute('data-st-toggle') + '"]', root);
        var on = box && box.checked; b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.textContent = on ? 'In your room ✓' : 'Add to room';
      });
    }
    function close() {
      if (!open) return;
      open.setAttribute('aria-expanded', 'false'); open = null; pop.hidden = true; pop.innerHTML = '';
    }
    function show(btn) {
      if (open === btn) { close(); return; }
      close();
      var tpl = $('template[data-st-card="' + btn.getAttribute('data-st-hot') + '"]', root);
      if (!tpl) return;
      pop.innerHTML = ''; pop.appendChild(tpl.content.cloneNode(true)); pop.hidden = false;
      btn.setAttribute('aria-expanded', 'true'); open = btn;
      if (window.matchMedia('(min-width: 750px)').matches) {
        var x = parseFloat(btn.style.getPropertyValue('--x')), y = parseFloat(btn.style.getPropertyValue('--y'));
        pop.style.left = (x > 55 ? 'auto' : 'calc(' + x + '% + 28px)');
        pop.style.right = (x > 55 ? 'calc(' + (100 - x) + '% + 28px)' : 'auto');
        pop.style.top = Math.max(4, Math.min(y - 18, 52)) + '%';
      } else { pop.style.left = pop.style.right = pop.style.top = ''; }
      sum();
      var f = $('a,button', pop); if (f) f.focus({ preventScroll: true });
    }
    root.addEventListener('click', function (e) {
      var h = e.target.closest('[data-st-hot]'); if (h) { show(h); return; }
      if (e.target.closest('[data-st-close]')) { var o = open; close(); if (o) o.focus(); return; }
      var t = e.target.closest('[data-st-toggle]');
      if (t) { var b = $('input[data-st-v="' + t.getAttribute('data-st-toggle') + '"]', root); if (b && !b.disabled) { b.checked = !b.checked; sum(); } return; }
      var a = e.target.closest('[data-st-add]');
      if (a) {
        var items = boxes.filter(function (b) { return b.checked && !b.disabled; }).map(function (b) { return { id: +b.getAttribute('data-st-v'), quantity: 1 }; });
        add(items, a, $('[data-st-msg]', root));
      }
      var one = e.target.closest('[data-st-one]');
      if (one) add([{ id: +one.getAttribute('data-st-one'), quantity: 1 }], one, $('[data-st-msg]', root));
    });
    root.addEventListener('change', function (e) { if (e.target.matches('input[data-st-v]')) sum(); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && open) { var o = open; close(); o.focus(); } });
    d.addEventListener('click', function (e) { if (open && !root.contains(e.target)) close(); });
    // Pulse hotspots once, the first time the room scrolls into view
    if (stage && 'IntersectionObserver' in window && !RM) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { stage.classList.add('is-pulse'); io.disconnect(); setTimeout(function () { stage.classList.remove('is-pulse'); }, 3200); } }, { threshold: 0.4 });
      io.observe(stage);
    }
    sum();
  }

  /* ---------- Design the complete room (compositions) ---------- */
  function compose(root) {
    var tabs = $$('[role="tab"]', root);
    function pick(i) {
      tabs.forEach(function (t, j) {
        var on = i === j; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1;
        var p = d.getElementById(t.getAttribute('aria-controls')); if (p) { p.hidden = !on; if (on) p.classList.add('is-in'); }
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { pick(i); });
      t.addEventListener('keydown', function (e) {
        var k = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!k) return;
        e.preventDefault(); var n = (i + k + tabs.length) % tabs.length; pick(n); tabs[n].focus();
      });
    });
    $$('[data-cp-panel]', root).forEach(function (p) {
      var boxes = $$('input[data-cp-v]', p);
      function sum() {
        var t = 0, n = 0;
        boxes.forEach(function (b) { var li = b.closest('li'); if (li) li.classList.toggle('is-off', !b.checked); if (b.checked && !b.disabled) { t += +b.getAttribute('data-cp-p'); n++; } });
        $('[data-cp-total]', p).textContent = money(t);
        $('[data-cp-count]', p).textContent = n + (n === 1 ? ' piece' : ' pieces');
      }
      p.addEventListener('change', sum);
      $('[data-cp-add]', p).addEventListener('click', function () {
        add(boxes.filter(function (b) { return b.checked && !b.disabled; }).map(function (b) { return { id: +b.getAttribute('data-cp-v'), quantity: 1 }; }), this, $('[data-cp-msg]', p));
      });
      sum();
    });
  }

  /* ---------- Design My Living Room: 2D planner ---------- */
  function planner(root) {
    var data; try { data = JSON.parse($('script[data-pl-data]', root).textContent); } catch (e) { return; }
    var form = $('[data-pl-form]', root), out = $('[data-pl-out]', root), unit = 'in';
    var STY = {
      warm: /atelier|rustic|drum|grange|echelle|échelle|raphia|jute|sable|nuage|cocon|fauve|walnut|oak|cane|malle/i,
      modern: /halo|opale|oslo|brume|slate|marble|conquest|cloud|velours|colonne|floating|dore|doré/i,
      natural: /raphia|jute|cane|oak|ash|drum|tourbillon|pivot|ivoire|sable|muse|duo|pliant/i
    };
    function rugSize(s) {
      var m = /(\d{1,2})\s*'?\s*(?:ft)?\s*[x×X]\s*(\d{1,2})/.exec(s || ''); if (!m) return null;
      var a = +m[1] * 12, b = +m[2] * 12; return { w: Math.max(a, b), d: Math.min(a, b) };
    }
    data.rugs.forEach(function (r) { var z = rugSize(r.vt) || rugSize(r.h.replace(/-/g, ' ')); if (z) { r.w = z.w; r.d = z.d; } });
    function score(p, style) { return (STY[style] && STY[style].test(p.t + ' ' + p.h + ' ' + p.vt)) ? 1 : 0; }
    function best(list, style, budget, ok) {
      var c = list.filter(function (p) { return p.ok && p.price <= budget && (!ok || ok(p)); });
      c.sort(function (a, b) { return (score(b, style) - score(a, style)) || (a.price - b.price); });
      return c[0] || null;
    }
    function toIn(v) { v = parseFloat(v); if (!(v > 0)) return 0; return unit === 'cm' ? v / 2.54 : v; }
    function fmt(inches) { return unit === 'cm' ? Math.round(inches * 2.54) + ' cm' : (Math.round(inches * 10) / 10) + '″'; }
    $$('[data-pl-unit]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var nu = b.getAttribute('data-pl-unit'); if (nu === unit) return;
        $$('input[data-pl-len]', form).forEach(function (i) { if (i.value) i.value = Math.round(nu === 'cm' ? i.value * 2.54 : i.value / 2.54); });
        unit = nu; $$('[data-pl-unit]', root).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        $$('[data-pl-u]', root).forEach(function (s) { s.textContent = unit; });
      });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var F = form.elements, W = toIn(F.rw.value), D = toIn(F.rd.value), style = F.sty.value, need = F.need.value;
      var budget = parseFloat(F.budget.value) * 100 || 1e12, room = F.room.value;
      if (W < 60 || D < 60) { out.innerHTML = '<p class="sxp-pl__warn" role="alert">Please enter the room width and depth (at least 60 in / 152 cm each).</p>'; return; }
      var left = budget, picks = [], notes = [];
      var walk = 30; // common guideline for a main walkway
      var sofa = best(data.sofas, style, left, function (p) {
        if (!(p.w > 0 && p.d > 0)) return false;
        if (need === 'sleep' && !p.bed) return false;
        var ow = Math.max(p.w, p.bl || 0);
        return ow <= W - 6 && D - p.d >= walk + 18;
      });
      if (!sofa) {
        var anyS = data.sofas.filter(function (p) { return p.ok; });
        out.innerHTML = '<p class="sxp-pl__warn" role="alert">None of the sofas currently in stock fits this room and budget' + (need === 'sleep' ? ' as a sleeper' : '') + '. ' +
          (anyS.length ? 'In-stock sofas: ' + anyS.map(function (s) { return esc(s.t) + ' (' + (s.w ? fmt(s.w) + ' wide' : 'width unconfirmed') + ', ' + money(s.price) + ')'; }).join('; ') + '.' : '') +
          ' Try a larger budget, or <a href="/pages/contact">ask us</a> and we will check with you.</p>';
        return;
      }
      picks.push({ role: 'Sofa', p: sofa, scale: true }); left -= sofa.price;
      var front = D - sofa.d;
      var rug = best(data.rugs, style, left, function (r) { return r.w && r.w <= W - 12 && r.d <= front + 12 && r.w >= Math.min(sofa.w * 0.75, 60); });
      if (rug) { picks.push({ role: 'Rug', p: rug, scale: true }); left -= rug.price; } else notes.push('No rug in stock fits this layout and budget.');
      var table = best(data.tables, style, left); if (table && front >= walk + 30) { picks.push({ role: 'Coffee table', p: table }); left -= table.price; }
      var big = W * D >= 120 * 132 || room === 'large';
      if (W - sofa.w >= 36 || big) { var chair = best(data.chairs, style, left); if (chair) { picks.push({ role: 'Accent chair', p: chair }); left -= chair.price; } }
      if (room !== 'large' || W - sofa.w >= 24) { var st = best(data.storage, style, left); if (st) { picks.push({ role: 'Storage', p: st }); left -= st.price; } }
      render(W, D, sofa, rug, picks, notes, front, walk);
    });
    function render(W, D, sofa, rug, picks, notes, front, walk) {
      var fs = Math.max(W, D) / 46, pad = fs * 2, vw = W + pad * 2, vh = D + pad * 2.6, sx = pad + (W - sofa.w) / 2, sy = pad + D - sofa.d - 2;
      var svg = '<svg viewBox="0 0 ' + vw + ' ' + vh + '" role="img" aria-label="Top-down plan of your room, ' + fmt(W) + ' by ' + fmt(D) + '" class="sxp-pl__svg" style="font-size:' + fs.toFixed(2) + 'px">' +
        '<rect x="' + pad + '" y="' + pad + '" width="' + W + '" height="' + D + '" class="r-room"/>';
      if (rug) { var rx = pad + (W - rug.w) / 2, ry = Math.max(pad + 4, sy + sofa.d * 0.55 - rug.d); svg += '<rect x="' + rx + '" y="' + ry + '" width="' + rug.w + '" height="' + rug.d + '" class="r-rug"/><text x="' + (rx + fs * 0.6) + '" y="' + (ry + fs * 1.3) + '" class="r-t">Rug ' + fmt(rug.w) + ' × ' + fmt(rug.d) + '</text>'; }
      svg += '<rect x="' + sx + '" y="' + sy + '" width="' + sofa.w + '" height="' + sofa.d + '" class="r-sofa"/><text x="' + (sx + sofa.w / 2) + '" y="' + (sy + sofa.d / 2 + fs * 0.35) + '" text-anchor="middle" class="r-t r-t--l">Sofa</text>';
      if (sofa.bed && sofa.bl > 0 && sofa.bw > 0) { var bwd = Math.max(sofa.w, sofa.bl), bx = pad + (W - bwd) / 2, by = sy + sofa.d - sofa.bw; svg += '<rect x="' + bx + '" y="' + by + '" width="' + bwd + '" height="' + sofa.bw + '" class="r-bed"/>'; }
      var markers = picks.filter(function (x) { return !x.scale; });
      var mr = fs * 1.3, top = sofa.bed && sofa.bw ? sy + sofa.d - sofa.bw : sy, ow = Math.max(sofa.w, sofa.bl || 0);
      var mpos = { 'Coffee table': [pad + W / 2, top - mr * 2.2], 'Accent chair': [Math.min(pad + W - mr * 3, pad + (W + ow) / 2 + mr * 2.4), top - mr * 2.4], 'Storage': [Math.max(pad + mr * 1.6, pad + (W - ow) / 2 - mr * 2.2), sy + sofa.d / 2] };
      markers.forEach(function (m, i) { var p = mpos[m.role] || [pad + mr * 2 + i * mr * 3, pad + mr * 2]; svg += '<g class="r-m"><circle cx="' + p[0] + '" cy="' + p[1] + '" r="' + mr + '"/><text x="' + p[0] + '" y="' + (p[1] + fs * 0.35) + '" text-anchor="middle">' + (picks.indexOf(m) + 1) + '</text></g>'; });
      svg += '<line x1="' + (pad + W - fs) + '" y1="' + pad + '" x2="' + (pad + W - fs) + '" y2="' + sy + '" class="r-dim"/><text x="' + (pad + W - fs * 1.5) + '" y="' + (pad + fs * 1.6) + '" text-anchor="end" class="r-t">' + fmt(front) + ' clear in front of sofa</text>';
      svg += '<text x="' + (pad + W / 2) + '" y="' + (vh - fs * 0.5) + '" text-anchor="middle" class="r-t">Back wall · ' + fmt(W) + ' · room depth ' + fmt(D) + '</text></svg>';
      var total = 0, rows = picks.map(function (x, i) {
        var p = x.p; total += p.price;
        var dims = x.scale ? fmt(p.w) + ' W × ' + fmt(p.d) + ' D' + (p.bed && p.bl && p.bw ? ' · bed ' + fmt(p.bl) + ' × ' + fmt(p.bw) : '') : 'Dimensions not confirmed on our site yet · shown as a marker, not to scale';
        return '<li><label><input type="checkbox" checked data-pl-v="' + p.v + '" data-pl-p="' + p.price + '"><span class="sxp-pl__n">' + (i + 1) + '</span></label>' +
          (p.img ? '<img src="' + esc(p.img) + '" alt="" width="64" height="64" loading="lazy">' : '<span></span>') +
          '<div><small>' + x.role + '</small><a href="' + esc(p.u) + '">' + esc(p.t) + '</a><small>' + dims + '</small></div><b>' + money(p.price) + '</b></li>';
      }).join('');
      var openFront = sofa.bed && sofa.bw ? D - sofa.bw : 0;
      var warn = sofa.bed && sofa.bw ? (openFront < walk ? '<p class="sxp-pl__warn">With the bed open, only about ' + fmt(Math.max(0, openFront)) + ' remains in front of it. Plan to move the coffee table when guests stay.</p>' : '<p class="sx-small">With the bed open, about ' + fmt(openFront) + ' remains in front of it; move the coffee table aside when the bed is out.</p>') : '';
      out.innerHTML = '<div class="sxp-pl__res is-in"><div class="sxp-pl__plan">' + svg + '<p class="sx-small">Plan drawn to scale from the confirmed sofa' + (rug ? ' and rug' : '') + ' dimensions' + (sofa.bed && sofa.bw ? '; the dashed outline is the open bed (' + fmt(sofa.bl) + ' × ' + fmt(sofa.bw) + ')' : '') + '. Numbered dots are pieces whose dimensions we have not confirmed yet. This is a preliminary guide, not a guarantee; check every measurement on the product page before ordering.</p></div>' +
        '<div><h3 class="sx-h3">Your suggested room</h3><ul class="sxp-pl__list" role="list">' + rows + '</ul>' + warn +
        (notes.length ? '<p class="sx-small">' + notes.join(' ') + '</p>' : '') +
        '<div class="sxp-total"><span>Total · <span data-pl-count>' + picks.length + ' pieces</span></span><b data-pl-total>' + money(total) + '</b></div>' +
        '<button type="button" class="sx-btn sxp-addbtn" data-pl-add><span>Add selected to cart</span></button><p class="sx-small" data-pl-msg role="status"></p>' +
        '<p class="sx-small">Free shipping to the 48 contiguous states. Pieces may ship in separate boxes and arrive on different days.</p></div></div>';
      var boxes = $$('input[data-pl-v]', out);
      if (!out.__pl) { out.__pl = 1; out.addEventListener('change', function () {
        var t = 0, n = 0; $$('input[data-pl-v]', out).forEach(function (b) { b.closest('li').classList.toggle('is-off', !b.checked); if (b.checked) { t += +b.getAttribute('data-pl-p'); n++; } });
        $('[data-pl-total]', out).textContent = money(t); $('[data-pl-count]', out).textContent = n + (n === 1 ? ' piece' : ' pieces');
      }); }
      $('[data-pl-add]', out).addEventListener('click', function () {
        add(boxes.filter(function (b) { return b.checked; }).map(function (b) { return { id: +b.getAttribute('data-pl-v'), quantity: 1 }; }), this, $('[data-pl-msg]', out));
      });
      out.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'nearest' });
    }
  }

  function init(scope) {
    $$('[data-sx-studio]', scope).forEach(function (r) { if (!r.__sx) { r.__sx = 1; studio(r); } });
    $$('[data-sx-compose]', scope).forEach(function (r) { if (!r.__sx) { r.__sx = 1; compose(r); } });
    $$('[data-sx-planner]', scope).forEach(function (r) { if (!r.__sx) { r.__sx = 1; planner(r); } });
  }
  function boot() { parallax(); init(d); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
